// extracted by mini-css-extract-plugin
export var bounce = "_jk-1";
export var generatingText = "_jk-6";
export var lightning = "_jk-4";
export var popup = "_jk-5";
export var progressBar = "_jk-7";
export var progressFill = "_jk-8";
export var progressShimmer = "_jk-9";
export var progressText = "_jk-a";
export var shimmer = "_jk-3";
export var uploadIcon = "_jk-0";
export var uploadingText = "_jk-2";